import { useState } from 'react';
import './CreateEvent.css';
import Header from './Header';
import addEventService from '../services/AddEventServices';
import { useAuth } from '../context/AuthContext';
import Swal from 'sweetalert2';

const CreateEvent = () => {
    const [nameEvent, setnameEvent] = useState('');
    const { token } = useAuth();

    const handleCreateEvent = async (e) => {
        e.preventDefault();
        try {
            const response = await addEventService(token, nameEvent);
            if (token && nameEvent) {
                setnameEvent('');

                Swal.fire({
                    title: '¡Evento Creado!',
                    text: 'el evento ' + response.name + ' fue creado con exito.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: 'btn btn-success',
                    },
                    buttonsStyling: false,
                })
            }
        } catch (error) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.message,
                customClass: {
                    title: "text-center"
                },
                showConfirmButton: false, // Mostrar el botón de confirmación
                timer: 2500,
                timerProgressBar: true,
            });
        }
    }

    return (
        <div className="events-container w-100">
            <Header />
            <div className="row external-bg-container-include d-flex justify-content-center align-items-start pt-5 vh-100 overflow-y-scroll">
                <div className="w-100 container d-flex justify-content-center align-items-center flex-column mt-5">
                    <div className="col-12 col-lg-6 mx-3 d-flex justify-content-center align-items-center flex-column mt-5">
                        <h1 className="text-center title-text-ranking fs-2 text-white mt-5">Crea un nuevo evento</h1>
                        <form className="login-form w-75 d-flex justify-content-center align-items-center flex-column" onSubmit={handleCreateEvent}>
                            <input
                                type="text"
                                className="text-red form-container-input text-center"
                                placeholder="nombre del evento"
                                value={nameEvent}
                                onChange={(e) => setnameEvent(e.target.value)}
                                title="Ingrese un correo electrónico válido"
                                required
                            />
                            <button type="submit" className="form-container-button w-70 lowercase">Crear evento</button>
                        </form>
                    </div>
                    <div className="col-12 col-lg-6 mx-3 d-flex justify-content-center align-items-center">
                        <img src="./aviancaLogo.png" className="container-logo-events" alt="avianca" />
                    </div>
                </div>
                {/* footer mobile */}
                <footer className="d-block d-md-block d-lg-none d-xl-none col-12 mt-auto">
                    <div className="d-flex justify-content-between align-items-center text-white mb-2">
                        <div className='mx-4 mb-3'>
                            <img src="./Logo-Footer-1.png" style={{ width: '70%' }} alt="logo" />
                        </div>
                        <div className='text-end mx-4 mb-3'>
                            <img src="./Logo-Footer-2.png" style={{ width: '150%', marginLeft: '-85px' }} alt="logo" />
                        </div>
                    </div>
                </footer>
                <footer className="d-none d-md-block d-lg-block d-xl-block col-12 mt-auto col-12 mt-auto bg-transparent">
                    <div className="d-flex justify-content-between align-items-center text-white mb-2">
                        <div className='mx-4 mb-3'>
                            <img src="./Logo-Footer-1.png" style={{ width: '40%' }} alt="logo" />
                        </div>
                        <div className='text-end mx-4 mb-3'>
                            <img src="./Logo-Footer-2.png" style={{ width: '60%' }} alt="logo" />
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    )
}

export default CreateEvent